import { render, staticRenderFns } from "./StarterPage.vue?vue&type=template&id=70f141e4&"
import script from "./StarterPage.vue?vue&type=script&lang=js&"
export * from "./StarterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports